const staticText = {
  title: 'Unsubscribe from webhook',
  confirm: 'Unsubscribe',
  cancel: 'Cancel',
  description: 'Are you sure you want to unsubscribe from |*|bold@@{{webhookName}}|*|?\nThis action cannot be undone.',
  disabledDescription: 'You may not have the appropriate permissions to perform this action.\nPlease consult the application owner or an admin on your team.',
};

export default staticText;
